module.exports = __webpack_public_path__ + "img/3.29_Russian_road_sign.d688fdf4.svg";